// @flow
import { ActionHelper } from 'modules/helper';
import { act } from 'react-dom/test-utils';

const actionTypePrefix = 'Home/';
export const HomeActionTypes = {
  BANNER: ActionHelper.createActionTypes(actionTypePrefix, 'BANNER'),
  HEADER: ActionHelper.createActionTypes(actionTypePrefix, 'HEADER'),
  CONTACTS: ActionHelper.createActionTypes(actionTypePrefix, 'CONTACTS'),
  VERTICALS: ActionHelper.createActionTypes(actionTypePrefix, 'VERTICALS'),
  SITE_SETTINGS: ActionHelper.createActionTypes(
    actionTypePrefix,
    'SITE_SETTINGS'
  ),
};
